import { UserPermissionConstants } from "../Constants";
import { UserPermissionDetail } from "../models/UserList";

export class PermissionHelper {
    public static GenerateAddCommentPermissionDetail(isAllowed: boolean) {
        return { permissionName: UserPermissionConstants.AddComment, isAllowed };
    }

  public static HasAddCommentPermission(userPermission: UserPermissionDetail[] | undefined | null): boolean {
    return PermissionHelper.HasPermission(userPermission, UserPermissionConstants.AddComment);
  }

  public static HasPermission(userPermission: UserPermissionDetail[] | undefined | null, permissionName: string): boolean {
    return userPermission?.some((permission) => permission.permissionName === permissionName && permission.isAllowed) || false;
  }
}
